module.exports = __webpack_public_path__ + "img/icon4.e028a97e.svg";